import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerComponent } from './color-picker.component';
import { ColorAreaComponent } from './color-area/color-area.component';
import { HueSliderComponent } from './hue-slider/hue-slider.component';
import { OpacitySliderComponent } from './opacity-slider/opacity-slider.component';
import { GradientColorToolComponent } from './gradient-color-tool/gradient-color-tool.component';
import { ColorPickerDialogComponent } from './color-picker-dialog.component';
import { MatSliderModule } from '@angular/material/slider';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialDesignModule } from '../material-design.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    ColorPickerComponent,
    ColorAreaComponent,
    HueSliderComponent,
    OpacitySliderComponent,
    GradientColorToolComponent,
    ColorPickerDialogComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MaterialDesignModule,
    MatSliderModule,
    FormsModule,
    MatTooltipModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
  ],
  exports: [ColorPickerComponent, GradientColorToolComponent],
})
export class ColorPickerModule {}
